var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"content"}},[_c('site-header'),(_vm.showEditor)?_c('blocks-editor'):_vm._e(),(!_vm.showEditor)?_c('blocks-renderer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }